import { useLocation } from "react-router-dom";
import queryString from "query-string";

export function useQueryParams() {
  return queryString.parse(useLocation().search);
}

export default useQueryParams;
